import { render, staticRenderFns } from "./receiver.vue?vue&type=template&id=3ebde9ac&scoped=true&"
import script from "./receiver.vue?vue&type=script&lang=ts&"
export * from "./receiver.vue?vue&type=script&lang=ts&"
import style0 from "./receiver.vue?vue&type=style&index=0&id=3ebde9ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebde9ac",
  null
  
)

export default component.exports